module.exports = __webpack_public_path__ + "static/media/Universitas Negeri Yogyakarta.c0c7dd12.png";